import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import WhitelabelIcon from '~/icons/components/WhitelabelIcon';
import ProductRating from '~/shared/components/ProductRating';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Container = styled.div`
  display: flex;
  align-items: center;
  ${({ theme: { reviewsModal } }) => reviewsModal.header.text}
`;

const Title = styled.p`
  font-weight: 700;
  margin-right: 8px;
`;

const countStyle = css`
  color: ${({ theme }) => theme.colors.reviewsCount};
`;

const wrapperStyle = css`
  margin: 0;
  display: flex;
`;

export default function ReviewsHeader({ headerId }) {
  return (
    <Container data-testid="reviews-header">
      <Title id={headerId}>
        <FormattedMessage
          id="site_pdp.reviews_component_link"
          defaultMessage="Reviews"
        />
      </Title>
      <ProductRating
        countStyle={countStyle}
        wrapperStyle={wrapperStyle}
        hideReviewCount={false}
        minReviewCount={1}
        emptyIcon={<WhitelabelIcon iconName="emptyStar" />}
        fullIcon={<WhitelabelIcon iconName="filledStar" />}
      />
    </Container>
  );
}

ReviewsHeader.propTypes = {
  headerId: PropTypes.string,
};
